"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalStyle = void 0;
const styled_components_1 = require("styled-components");
const breakpoints_1 = require("./breakpoints");
const dark_1 = __importDefault(require("./dark"));
const light_1 = __importDefault(require("./light"));
const verse_1 = __importDefault(require("./verse"));
const themes = {
    dark: dark_1.default,
    light: light_1.default,
    verse: verse_1.default,
};
exports.GlobalStyle = (0, styled_components_1.createGlobalStyle) `
  html {
    scroll-behavior: smooth;
  }

  html,
  body,
  ___gatsby,
  ___gatsby > div {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
    margin: 0;
    padding: 0;
    color: ${({ theme }) => theme.palette.text.default};
    background:${({ theme }) => theme.palette.background.default};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    text-decoration: none;
  }

  button.osano-cm-widget {
    display: none;
  }

  .osano-cm-dialog--type_box.osano-cm-dialog--position_bottom-right {
    bottom: unset;
    right: unset;
    max-width: unset;
    width: 100%;
    background: #FFFFFF;
    ${breakpoints_1.media.md `
      bottom: 1em;
      right: 1em;
      max-width: 20em;
      width: calc(100vw - 2em);
      background: rgba(255,255,255,0.7);
    `}
    .os-close-btn {
      background: white;
      border: 1px solid;
      cursor: pointer;
      padding: 8px;
      width: 100%;
      border-radius: 0.25em;
      margin-top: 12px;
      font-weight: 600;
      font-size: 15px;
    }
  }
`;
exports.default = themes;
//# sourceMappingURL=index.js.map